class TruspilotReviews extends HTMLElement {
  constructor() {
    super();

    if (this.querySelector(".swiper-truspilot")) {
      const swiper = new Swiper(this.querySelector(".swiper-truspilot"), {
        // Optional parameters
        direction: "horizontal",
        spaceBetween: 9,
        loop: false,
        slidesPerView: 1,
        centeredSlides: false,
        breakpoints: {
          750: {
            slidesPerView: 1.8,
            spaceBetween: 10,
          },
          990: {
            slidesPerView: 2.3,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 2.8,
          },
        },
        // If we need pagination
        pagination: {
          el: this.querySelector(".swiper-pagination"),
        },
      });
    }

    this.review_to_show = this.querySelector("[data-nb-reviews]")
      ? Number(
          this.querySelector("[data-nb-reviews]").getAttribute(
            "data-nb-reviews"
          )
        )
      : 6;

    this.review_to_show_step = this.querySelector("[data-nb-reviews]")
      ? Number(
          this.querySelector("[data-nb-reviews]").getAttribute(
            "data-nb-reviews"
          )
        )
      : 6;
    console.log(this.review_to_show);

    this.querySelector(".load-more__button").addEventListener(
      "click",
      this.load_more_reviews_3_by_3.bind(this)
    );
  }
  load_more_reviews_3_by_3() {
    let reviews = this.querySelectorAll(".truspilot-review");
    let nb_reviews = reviews.length;
    let nb_reviews_to_show = this.review_to_show + this.review_to_show_step;

    if (nb_reviews_to_show > nb_reviews) {
      nb_reviews_to_show = nb_reviews;
      this.querySelector(".load-more__button").classList.add("hidden");
    }

    for (let i = this.review_to_show; i < nb_reviews_to_show; i++) {
      reviews[i].classList.remove("hidden");
    }

    this.review_to_show = nb_reviews_to_show;
  }
}
customElements.define("truspilot-reviews", TruspilotReviews);
